// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"375":"82bf74a4","400":"3f9da68d","408":"cc2bcc2b","579":"b6752a26","696":"334d1fd2","928":"cbc71e76","960":"04f253b1"}[chunkId] + ".chunk.js";
};